(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["infinite-scroll-container"] && !Shopify.designMode) return;
  try {
    class InfiniteScrollContainer extends HTMLElement {
    constructor() {
      super();
      this.loadMoreButton = this.querySelector('[data-infinite-scroll-load-more]');
      this.autoLoader = this.querySelector('[data-infinite-scroll-auto-loader]');
      this.sentinel = this.querySelector('[data-infinite-scroll-sentinel]');
      this.productsContainer = this.querySelector('.infinite-scroll-container__products');
      this.productList = this.productsContainer?.querySelector('product-list');
      this.statusContainer = this.querySelector('.infinite-scroll-container__status');
      this.countElement = this.querySelector('.infinite-scroll-container__count');
      
      this.collectionUrl = this.dataset.collectionUrl;
      this.sectionId = this.dataset.sectionId;
      this.productsPerLoad = parseInt(this.dataset.productsPerLoad, 10);
      this.firstPageCount = parseInt(this.dataset.firstPageCount, 10);
      this.totalProducts = parseInt(this.dataset.totalProducts, 10);
      this.autoLoad = this.dataset.autoLoad === 'true';
      this.productsPerRow = parseInt(this.dataset.productsPerRow, 10) || 4;
      
      this.currentPage = 1;
      this.loadedProducts = Math.min(this.firstPageCount, this.totalProducts);
      this.isLoading = false;
      this.observer = null;
      
      this.init();
    }

    init() {
      this.restoreStateFromHistory();
      
      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', this.handleLoadMore.bind(this));
      }

      if (this.autoLoad && this.sentinel) {
        this.setupIntersectionObserver();
      }

      window.addEventListener('popstate', this.handlePopState.bind(this));
    }

    setupIntersectionObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoading && this.loadedProducts < this.totalProducts) {
            this.triggerAutoLoad();
          }
        });
      }, {
        root: null,
        rootMargin: '400px',
        threshold: 0
      });
      
      this.observer.observe(this.sentinel);
    }

    async triggerAutoLoad() {
      if (this.isLoading) return;
      
      this.isLoading = true;
      if (this.autoLoader) {
        this.autoLoader.hidden = false;
      }
      
      const nextPage = this.currentPage + 1;
      const url = this.buildPageUrl(nextPage);
      
      try {
        const productsAdded = await this.fetchAndAppendProducts(url, true);
        this.currentPage = nextPage;
        this.updateHistoryState();
        this.checkIfMoreProducts();
      } catch (error) {
        console.error('Error auto-loading products:', error);
      } finally {
        this.isLoading = false;
      }
    }

    checkIfMoreProducts() {
      const hasMore = this.loadedProducts < this.totalProducts;
      
      if (this.autoLoader) {
        this.autoLoader.hidden = !hasMore;
      }
      
      if (this.loadMoreButton) {
        this.loadMoreButton.hidden = !hasMore || this.autoLoad;
      }
      
      if (!hasMore && this.observer) {
        this.observer.disconnect();
      }
    }

    restoreStateFromHistory() {
      const state = history.state;
      if (state && state.infiniteScrollPage && state.infiniteScrollPage > 1) {
        this.loadPagesToPage(state.infiniteScrollPage);
      }
    }

    async loadPagesToPage(targetPage) {
      this.isLoading = true;
      this.updateButtonState(true);
      if (this.autoLoader) {
        this.autoLoader.hidden = false;
      }
      
      for (let page = 2; page <= targetPage; page++) {
        const url = this.buildPageUrl(page);
        await this.fetchAndAppendProducts(url, false);
        this.currentPage = page;
      }
      
      this.loadedProducts = Math.min(
        this.firstPageCount + (targetPage - 1) * this.productsPerLoad,
        this.totalProducts
      );
      this.updateCount();
      
      this.isLoading = false;
      this.updateButtonState(false);
      this.checkIfMoreProducts();
    }

    handlePopState(event) {
      if (event.state && event.state.infiniteScrollPage) {
        location.reload();
      }
    }

    buildPageUrl(page) {
      const url = new URL(this.collectionUrl, window.location.origin);
      url.searchParams.set('page', page);
      
      const currentParams = new URLSearchParams(window.location.search);
      for (const [key, value] of currentParams) {
        if (key !== 'page') {
          url.searchParams.set(key, value);
        }
      }
      
      return url;
    }

    async handleLoadMore(event) {
      if (event) event.preventDefault();
      
      if (this.isLoading) return;
      
      this.isLoading = true;
      this.updateButtonState(true);
      
      const nextPage = this.currentPage + 1;
      const url = this.buildPageUrl(nextPage);
      
      try {
        await this.fetchAndAppendProducts(url, true);
        this.currentPage = nextPage;
        this.updateHistoryState();
        this.checkIfMoreProducts();
      } catch (error) {
        console.error('Error loading more products:', error);
      } finally {
        this.isLoading = false;
        this.updateButtonState(false);
      }
    }

    async fetchAndAppendProducts(url, updateCount = true) {
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', this.sectionId);
      
      const response = await fetch(fetchUrl.toString());
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newProductList = doc.querySelector('.infinite-scroll-container__products product-list');
      let productsAdded = 0;
      
      if (newProductList && this.productList) {
        const newItems = newProductList.querySelectorAll(':scope > *:not(.product-list__promo)');
        const fragment = document.createDocumentFragment();
        
        newItems.forEach(item => {
          const clonedItem = document.importNode(item, true);
          clonedItem.removeAttribute('reveal-on-scroll');
          clonedItem.style.opacity = '1';
          
          const revealElements = clonedItem.querySelectorAll('[reveal-on-scroll]');
          revealElements.forEach(el => {
            el.removeAttribute('reveal-on-scroll');
            el.style.opacity = '1';
          });
          
          fragment.appendChild(clonedItem);
          productsAdded++;
        });
        
        this.productList.appendChild(fragment);
        
        if (updateCount) {
          this.loadedProducts = Math.min(this.loadedProducts + productsAdded, this.totalProducts);
          this.updateCount();
        }
      }
      
      const newButton = doc.querySelector('[data-infinite-scroll-load-more]');
      if (newButton) {
        const newNextUrl = newButton.dataset.nextUrl;
        if (this.loadMoreButton && newNextUrl) {
          this.loadMoreButton.dataset.nextUrl = newNextUrl;
        }
      }
      
      return productsAdded;
    }

    updateHistoryState() {
      const url = new URL(window.location.href);
      url.searchParams.set('page', this.currentPage);
      
      history.replaceState(
        { 
          infiniteScrollPage: this.currentPage,
          loadedProducts: this.loadedProducts
        }, 
        '', 
        url.toString()
      );
    }

    updateButtonState(isLoading) {
      if (this.loadMoreButton) {
        this.loadMoreButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        this.loadMoreButton.disabled = isLoading;
      }
    }

    updateCount() {
      if (this.countElement) {
        const countText = this.countElement.textContent;
        const match = countText.match(/(\d+)\s+of\s+(\d+)/i);
        if (match) {
          const newText = countText.replace(/\d+\s+of/, `${this.loadedProducts} of`);
          this.countElement.textContent = newText;
        } else {
          this.countElement.textContent = `Showing ${this.loadedProducts} of ${this.totalProducts} products`;
        }
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  if (!window.customElements.get('infinite-scroll-container')) {
    window.customElements.define('infinite-scroll-container', InfiniteScrollContainer);
  }
  } catch(e) { console.error(e); }
})();

})();
